import VueLazyload from "vue-lazyload";

import { Lazyload } from "vant";
import Vue from "vue";
import Vant from "vant";
import CloudFramework from "cf";
// require styles
import "static/summernote/summernote-lite.css";
import "@/assets/flags/famfamfam-flags.css";

import "./filters.js";
import { fomratDateTime, fomratDate } from "../format/dateFormat";
import { AppConsts } from "cf/packages/abpVue/AppConsts";
import "static/iconfont/iconfont.css";
import "static/iconfont/font-awesome.min.css";
import "vant/lib/index.css";

import "animate.css";
import "static/videojs/video-js.css";
import "@/assets/mobile.less";
import { Loading } from "element-ui";
import Mobile from "@/assets/Mobile.js";
import "@/shared/views/register.js";
import watermark from "watermark-dom";

Vue.use(Vant);
Vue.use(CloudFramework);
Vue.use(Loading.directive);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/img/avatar3_small.jpg",
  loading: "/static/img/loading.gif",
  try: 1
});
Vue.mixin({
  mounted() {
    if (AppConsts.site.is_system_watermark == "Y") {
      if (abp && abp.userInfo) {
        watermark.load({
          watermark_txt: abp.userInfo.loginId
            ? this.l("NEIBUZILIAO") + " " + abp.userInfo.loginId
            : " ",
          watermark_fontsize: "13px",
          watermark_x_space: 20,
          watermark_width: 110 //水印宽度
        });
      }
    }
  },
  destroyed() {
    watermark.load({ watermark_txt: " " });
  }
});
Vue.prototype.ueConfig = { index: 999 };
Vue.prototype.config = AppConsts;
Vue.prototype.systemDateTimeFormat = fomratDateTime;
Vue.prototype.systemDateFormat = fomratDate;
Vue.prototype.imagePath = (cover, vertical) => {
  if (cover) {
    return (
      this.app.remoteServiceBaseUrl + "sys/file/previewFile?fileName=" + cover
    );
  }
  return "/static/img/error" + (vertical ? "_v" : "") + ".gif";
};
Vue.prototype.avatarPath = (cover, vertical) => {
  if (cover) {
    return (
      this.app.remoteServiceBaseUrl + "sys/file/previewFile?fileName=" + cover
    );
  }
  return "/static/img/avatar3_small.jpg";
};

Vue.prototype.fileTypeIconFilter = fileType => {
  switch (fileType.toUpperCase()) {
    case "DOC":
    case "DOCX":
      return "doc";
    case "PPT":
    case "PPTX":
      return "ppt";
    case "XLS":
    case "XLSX":
      return "xls";
    case "TXT":
      return "txt";
    default:
      return "";
  }
};

const $event = new Vue();
Vue.prototype.$event = $event;

//数组移出方法
Array.prototype.remove = val => {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

Vue.prototype.getTimeBySeconds = result => {
  var h =
    Math.floor(result / 3600) < 10
      ? "0" + Math.floor(result / 3600)
      : Math.floor(result / 3600);
  var m =
    Math.floor((result / 60) % 60) < 10
      ? "0" + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  var s =
    Math.floor(result % 60) < 10
      ? "0" + Math.floor(result % 60)
      : Math.floor(result % 60);

  return (result = h + ":" + m + ":" + s);
};

//导航返回方法
Vue.prototype.navLeft = () => {
  if (vm.$route.query.returnUrl) {
    //如果存在returnUrl 优先return
    window.location.href = vm.$route.query.returnUrl;
  } else if (
    vm.$route.query.close ||
    vm.$route.name == "Home" ||
    vm.$route.name == "Guest"
  ) {
    //如果存在close 则直接关闭webapp
    abp.auth.clearToken();
    localStorage.clear();
    vm.$mobile.closeView();
  } else {
    vm.$router.go(-1);
  }
};

Vue.prototype.navRight = () => {
  vm.$router.push({
    path: "/Search",
    query: { businessType: vm.$route.meta.searchType }
  });
};

Vue.prototype.$mobile = Mobile;



// WEBPACK FOOTER //
// ./src/config/global/mobile.index.js